"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toolbox["default"];
  }
});
var _Toolbox = _interopRequireDefault(require("./Toolbox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }